module.exports = __webpack_public_path__ + "static/media/tour_background.87cc725a.svg";